/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemDetailsModel } from '../../models/system-details-model';

export interface SystemSearch$Params {
  systemSerialNumberORFunctionalLocation: string;
  modalityId?: Array<number>;
}

export function systemSearch(http: HttpClient, rootUrl: string, params: SystemSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemDetailsModel>>> {
  const rb = new RequestBuilder(rootUrl, systemSearch.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumberORFunctionalLocation', params.systemSerialNumberORFunctionalLocation, {});
    rb.query('modalityId', params.modalityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystemDetailsModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
systemSearch.PATH = '/api/systemoverview/search/{systemSerialNumberORFunctionalLocation}';
systemSearch.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
systemSearch.ROOTURL = '/portal';
